import { jsPDF } from "jspdf";
import QRCode from "qrcode";
import { imgEncabezado2 } from "../../../helpers/imgBase64.js";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatDateTime = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const days = [
    "DOMINGO",
    "LUNES",
    "MARTES",
    "MIÉRCOLES",
    "JUEVES",
    "VIERNES",
    "SÁBADO",
  ];
  const months = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];

  const dayName = days[date.getDay()];
  const day = date.getDate().toString().padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `SIENDO LAS ${hours}:${minutes} HRS DEL ${dayName} ${day} DE ${month} DEL ${year}`;
};

export const oficio_cna = async (datos, item) => {
  console.log(datos);
  try {
    // Crear el documento PDF
    const doc = new jsPDF("p", "pt", "letter");

    var startY = 20;

    doc.addImage(imgEncabezado2, "JPEG", 40, (startY += 10), 230, 60);
    doc.setFontSize(11);

    doc.setFont("Helvetica", "bold");

    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;

    const qrText = datos._id;
    const qrCodeDataURL = await QRCode.toDataURL(qrText, { width: 228 });
    if (qrCodeDataURL) {
      const qrWidth = 80; // Ancho del QR más pequeño
      const qrHeight = 80; // Altura del QR más pequeño
      const qrXPosition = pageWidth - qrWidth - 40; // Posiciona el QR en la esquina derecha superior
      const qrYPosition = 15; // Posición vertical en la parte superior

      doc.addImage(
        qrCodeDataURL,
        "PNG",
        qrXPosition,
        qrYPosition,
        qrWidth,
        qrHeight
      );
    } else {
      console.error("Error al generar el código QR");
    }

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(9);
    doc.text(["CERTIFICADO DE NO ADEUDO."], 280, 55);

    let folioText = "";

    if (datos.tipo === "Liquidado") {
      folioText = `APITAB-OP-F-${datos.folio_cna}-CNA`;
    } else {
      if (datos.pagado) {
        folioText = `APITAB-OP-F-${datos.folio_cna}-CNA-B`;
      } else {
        folioText = `APITAB-OP-F-${datos.folio_cna}-CNA-A`;
      }
    }

    doc.text(folioText, 300, 70);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(9);
    doc.text(["FOLIO: "], 450, 100);

    doc.setFont("Helvetica", "bold");
    doc.setFontSize(9);
    doc.text([item.folio_solicitud], 485, 100);
    doc.setDrawColor(0, 0, 0);
    doc.line(485, 102, 580, 102);

    doc.setFont("Helvetica", "bold");
    doc.setFontSize(9);
    doc.text(["LIC. ALEJANDRO ROMERO REYES"], 40, 100);

    doc.setFont("Helvetica", "bold");
    doc.setFontSize(9);
    doc.text(["CAPITAN DE PUERTO"], 40, 110);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(9);
    doc.text(["Frontera, Tabasco"], 40, 120);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(
      [
        "La Administracion Portuario Inegral de Tabasco, S.A. de C.V. a solicitud de:",
      ],
      40,
      140
    );

    doc.setFont("Helvetica", "bold");
    doc.setFontSize(10);
    doc.text(item.agencia.nombre, 200, 160);
    doc.setDrawColor(0, 0, 0);
    doc.line(40, 162, 580, 162);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(
      [
        "Con base a las facultades conferidas en el Art. 40 y en cumplimiento a lo previsto por los Art. 41 de la Ley de",
      ],
      40,
      180
    );
    doc.text(
      [
        "Puertos así como en el Art. 66-A fracción II del Reglamento de la Ley de Navegación y Comercio Marítimo, se emite",
      ],
      40,
      195
    );
    doc.text(
      ["el presente Certificado de No Adeudo, en virtud de que el usuario ha:"],
      40,
      210
    );

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["LIQUIDADO"], 120, 230);
    doc.rect(200, 220, 20, 13);
    if (datos.tipo === "Liquidado") {
      doc.text(["X"], 205, 230);
    }
    doc.text(["GARANTIZADO"], 355, 230);
    doc.rect(450, 220, 20, 13);
    if (datos.tipo === "Garantizado") {
      doc.text(["X"], 455, 230);
    }

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(
      [
        "El pago del uso de la infraestructura en el Puerto de Frontera por los conceptos:",
      ],
      40,
      250
    );

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Tráfico a Altura"], 40, 270);
    doc.rect(140, 260, 20, 13);
    if (
      datos.uso_infraestructura &&
      datos.uso_infraestructura.includes("Tráfico de altura")
    ) {
      doc.text(["X"], 145, 270);
    }

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Puerto Fijo"], 190, 270);
    doc.rect(270, 260, 20, 13);
    if (
      datos.uso_infraestructura &&
      datos.uso_infraestructura.includes("Puerto Fijo")
    ) {
      doc.text(["X"], 275, 270);
    }

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Atraque"], 300, 270);
    doc.rect(350, 260, 20, 13);
    if (
      datos.uso_infraestructura &&
      datos.uso_infraestructura.includes("Atraque")
    ) {
      doc.text(["X"], 355, 270);
    }

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Puerto menor 500 Ton."], 390, 270);
    doc.rect(500, 260, 20, 13);
    if (
      datos.uso_infraestructura &&
      datos.uso_infraestructura.includes("Puerto menor 500 ton")
    ) {
      doc.text(["X"], 505, 270);
    }

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Tráfico de Cabotaje"], 40, 290);
    doc.rect(140, 280, 20, 13);
    if (
      datos.uso_infraestructura &&
      datos.uso_infraestructura.includes("Tráfico de cabotaje")
    ) {
      doc.text(["X"], 145, 290);
    }

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Puerto Variable"], 190, 290);
    doc.rect(270, 280, 20, 13);
    if (
      datos.uso_infraestructura &&
      datos.uso_infraestructura.includes("Puerto variable")
    ) {
      doc.text(["X"], 275, 290);
    }

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Muellaje"], 300, 290);
    doc.rect(350, 280, 20, 13);
    if (
      datos.uso_infraestructura &&
      datos.uso_infraestructura.includes("Muellaje")
    ) {
      doc.text(["X"], 355, 290);
    }

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Pasajeros"], 390, 290);
    doc.rect(500, 280, 20, 13);
    if (
      datos.uso_infraestructura &&
      datos.uso_infraestructura.includes("Pasajeros")
    ) {
      doc.text(["X"], 505, 290);
    }

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Características de la embarcación:"], 40, 305);

    doc.setFontSize(10);
    doc.text(["Nombre del buque:"], 40, 320);
    doc.setDrawColor(0, 0, 0);
    doc.line(125, 322, 250, 322);

    doc.setFontSize(10);
    doc.setFont("Helvetica", "bold");
    doc.text([item.embarcacion?.nombre || "N/A"], 130, 320);

    doc.setFontSize(10);
    doc.setFont("Helvetica", "normal");
    doc.text(["Bandera:"], 270, 320);

    doc.setFont("Helvetica", "bold");
    doc.text([item.embarcacion?.bandera || "N/A"], 320, 320);
    doc.setDrawColor(0, 0, 0);
    doc.line(315, 322, 400, 322);

    doc.setFontSize(10);
    doc.setFont("Helvetica", "normal");
    doc.text(["Tráfico:"], 420, 320);

    doc.setFontSize(10);
    doc.setFont("Helvetica", "bold");
    doc.text([item.embarcacion?.tipo || "N/A"], 460, 320);
    doc.setDrawColor(0, 0, 0);
    doc.line(455, 322, 580, 322);

    doc.setFont("Helvetica", "normal");
    doc.text(["No. De Matrícula:"], 40, 335);
    doc.setFont("Helvetica", "bold");
    doc.text([item.embarcacion?.matricula || "N/A"], 120, 335);
    doc.setDrawColor(0, 0, 0);
    doc.line(120, 337, 200, 337);

    doc.setFont("Helvetica", "normal");
    doc.text(["PTO. MATRICULA:"], 223, 335);
    doc.setFont("Helvetica", "bold");
    doc.text([item.embarcacion?.pto_matricula || "N/A"], 315, 335);
    doc.setDrawColor(0, 0, 0);
    doc.line(315, 337, 580, 337);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["TRB:"], 45, 350);
    doc.setFont("Helvetica", "bold");
    doc.text([item.embarcacion?.tbr?.toString() || "N/A"], 90, 350);
    doc.setDrawColor(0, 0, 0);
    doc.line(75, 352, 120, 352);

    doc.setFont("Helvetica", "normal");
    doc.text(["TRN:"], 130, 350);
    doc.setFont("Helvetica", "bold");
    doc.text([item.embarcacion?.trn || "N/A"], 175, 350);
    doc.setDrawColor(0, 0, 0);
    doc.line(155, 352, 200, 352);

    doc.setFont("Helvetica", "normal");
    doc.text(["Eslora:"], 210, 350);
    doc.setFont("Helvetica", "bold");
    doc.text(
      [item.embarcacion?.eslora ? `${item.embarcacion.eslora} M` : "N/A"],
      260,
      350
    );
    doc.setDrawColor(0, 0, 0);
    doc.line(245, 352, 310, 352);

    doc.setFont("Helvetica", "normal");
    doc.text(["Manga:"], 320, 350);
    doc.setFont("Helvetica", "bold");
    doc.text(
      [item.embarcacion?.manga ? `${item.embarcacion.manga} M` : "N/A"],
      365,
      350
    );
    doc.setDrawColor(0, 0, 0);
    doc.line(355, 352, 415, 352);

    doc.setFont("Helvetica", "normal");
    doc.text(["Calado:"], 430, 350);
    doc.setFont("Helvetica", "bold");
    doc.text([item.embarcacion?.calado || "N/A"], 480, 350);
    doc.setDrawColor(0, 0, 0);
    doc.line(470, 352, 530, 352);

    doc.setFont("Helvetica", "normal");
    doc.text(["Puntal:"], 40, 365);
    doc.setFont("Helvetica", "bold");
    doc.text([item.embarcacion?.puntal || "N/A"], 75, 365);
    doc.setDrawColor(0, 0, 0);
    doc.line(75, 367, 120, 367);

    doc.setFont("Helvetica", "normal");
    doc.text(["IMO:"], 130, 365);
    doc.setFont("Helvetica", "bold");
    doc.text([item.embarcacion?.imo || "N/A"], 165, 365);
    doc.setDrawColor(0, 0, 0);
    doc.line(155, 367, 200, 367);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Datos de arribo de la embarcación:"], 250, 385);

    doc.text(["Puerto de procedencia:"], 40, 400);
    doc.setFont("Helvetica", "bold");
    doc.text([item.puerto_procedencia || "N/A"], 160, 400);
    doc.setDrawColor(0, 0, 0);
    doc.line(155, 402, 580, 402);

    doc.setFont("Helvetica", "normal");
    doc.text(["Fecha de arribo:"], 40, 415);
    doc.setFont("Helvetica", "bold");
    doc.text([formatDate(datos.fecha_atraque) || ""], 160, 415);
    doc.setDrawColor(0, 0, 0);
    doc.line(155, 417, 365, 417);

    doc.setFont("Helvetica", "normal");
    doc.text(["Hora de arribo:"], 370, 415);
    doc.setFont("Helvetica", "bold");
    doc.text([datos.hora_atraque || ""], 460, 415);
    doc.setDrawColor(0, 0, 0);
    doc.line(455, 417, 580, 417);

    doc.setFont("Helvetica", "normal");
    doc.text(["Muelle:"], 40, 430);
    doc.setFont("Helvetica", "bold");
    doc.text([item.muelle || ""], 80, 430);
    doc.setDrawColor(0, 0, 0);
    doc.line(75, 432, 315, 432);

    doc.setFont("Helvetica", "normal");
    doc.text(["Terminal:"], 320, 430);
    doc.setFont("Helvetica", "bold");
    doc.text(["APITAB"], 375, 430);
    doc.setDrawColor(0, 0, 0);
    doc.line(335, 432, 580, 432);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Datos de destino de la embarcación:"], 250, 450);

    doc.text(["Puerto destino:"], 40, 465);
    doc.setFont("Helvetica", "bold");
    doc.text([datos.puerto_destino || ""], 160, 465);
    doc.setDrawColor(0, 0, 0);
    doc.line(150, 467, 580, 467);

    doc.setFont("Helvetica", "normal");
    doc.text(["Fecha de zarpe:"], 40, 480);
    doc.setFont("Helvetica", "bold");
    doc.text([formatDate(datos.fecha_zarpe) || ""], 160, 480);
    doc.setDrawColor(0, 0, 0);
    doc.line(150, 482, 365, 482);

    doc.setFont("Helvetica", "normal");
    doc.text(["Hora de zarpe:"], 370, 480);
    doc.setFont("Helvetica", "bold");
    doc.text([datos.hora_zarpe || ""], 460, 480);
    doc.setDrawColor(0, 0, 0);
    doc.line(445, 482, 580, 482);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Realiza operaciones de:"], 40, 500);
    doc.setFont("Helvetica", "bold");
    doc.text([datos.detalles || ""], 160, 500);
    doc.setDrawColor(0, 0, 0);
    doc.line(150, 502, 580, 502);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Tipo de carga:"], 270, 520);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["General suelta:"], 40, 540);
    doc.rect(125, 528, 35, 15);
    if (datos.tipo_carga === "General Suelta") {
      doc.text(["X"], 140, 540);
    }

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Lastre:"], 210, 540);
    doc.rect(245, 528, 35, 15);
    if (datos.tipo_carga === "Lastre") {
      doc.text(["X"], 260, 540);
    }

    doc.setFontSize(10);
    doc.setFont("Helvetica", "normal");
    doc.text(["Otro:"], 350, 540);
    doc.setFont("Helvetica", "bold");
    if (
      datos.tipo_carga !== "General Suelta" &&
      datos.tipo_carga !== "Lastre"
    ) {
      doc.text([datos.tipo_carga || ""], 385, 540);
    }
    doc.setDrawColor(0, 0, 0);
    doc.line(380, 542, 580, 542);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Producto:"], 40, 560);
    doc.line(105, 562, 350, 562);

    doc.setFontSize(10);
    doc.setFont("Helvetica", "normal");
    doc.text(["Total de Toneladas:"], 360, 560);
    doc.setFont("Helvetica", "bold");
    doc.text([`${datos.total_ton} TON`], 460, 560);
    doc.line(455, 562, 580, 562);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Nombre del representante autorizado por la Agencia"], 40, 580);
    doc.text(["Consignaria:"], 40, 595);
    doc.setFont("Helvetica", "bold");
    doc.text([item.solicitante || ""], 40, 610);
    doc.setFont("Helvetica", "normal");
    doc.line(40, 620, 350, 620);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Firma de conformidad del representante:"], 360, 595);
    doc.line(360, 620, 580, 620);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["Fecha y hora de elaboración:"], 40, 640);

    doc.setFont("Helvetica", "bold");
    doc.setFontSize(10);
    doc.text([formatDateTime(datos.createdAt)], 220, 640);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(["APROBO"], 120, 660);
    doc.line(50, 675, 250, 675);
    //doc.text([datos.solicitante.nombre], 150, 685, { align: "center" });
    //doc.text([datos.solicitante.cargo], 150, 700, { align: "center" });
    doc.text([datos.solicitante.nombre], 150, 685, { align: "center" });
    doc.text([datos.solicitante.cargo], 150, 700, { align: "center" });
    doc.text(["Por ausencia del Administrador"], 70, 715);

    doc.setFont("Helvetica", "bold");
    doc.setFontSize(10);
    doc.text(
      [
        "Este documento tiene una vigencia de 48 Hrs. A partir de la fecha y hora de la expedición.",
      ],
      60,
      725
    );

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(10);
    doc.text(
      [
        "Este certificado se expide por duplicado y no sera valido si carece de las firmas y sellos correspondientes.",
      ],
      50,
      740
    );

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
      [
        "Recinto Fiscal Autorizado Pino Suarez Esq. Muelle Fiscal Col. Centro C.P. 86751 Frontera, Tabasco.",
      ],
      110,
      760
    );
    doc.text(
      [
        "e-mail:administracion@apitabasco.mx, Tel.: 913-33-2-12-88 y 913-33-2-08-05",
      ],
      130,
      770
    );

    const pdfOutput = doc.output("blob");

    // Create a URL for the Blob
    const pdfUrl = URL.createObjectURL(pdfOutput);

    // Open the PDF preview in a new window
    window.open(pdfUrl, "_blank");
  } catch (error) {
    console.error("Error generando el PDF:", error);
    throw new Error("No se pudo generar el PDF");
  }
};

const formatFolio = (folio, muelle, created) => {
  const folio_number = folio.toString().padStart(4, "0");
  const date = new Date(created);
  const day = date.getUTCDate().toString().padStart(2, "0"); // Asegura dos dígitos
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = date.getUTCFullYear();
  let muelle_folio = "";
  if (
    muelle == "CHILTEPEC" ||
    muelle == "MUELLE DE TANQUES" ||
    muelle == "MUELLE PESCADORES CHILTEPEC"
  ) {
    muelle_folio = "CH";
  } else {
    muelle_folio = "FR";
  }
  let clave_muelle = "";
  switch (muelle) {
    case "ESPADAÑAL":
      clave_muelle = "PAR";
      break;
    case "CENTRO DE REPARACIONES NAVALES":
      clave_muelle = "PAR";
      break;
    case "MUELLE PESCADORES FRONTERA":
      clave_muelle = "DEP";
      break;
    case "MUELLE FISCAL":
      clave_muelle = "FIS";
      break;
    case "PARTICULAR":
      clave_muelle = "PAR";
      break;
    case "MUELLE DE TANQUES":
      clave_muelle = "PAR";
      break;
    case "MUELLE PESCADORES CHILTEPEC":
      clave_muelle = "PES";
      break;
    case "SANCHEZ MAGALLANES":
      clave_muelle = "PAR";
      break;
    case "MUELLE DE TANQUES":
      clave_muelle = "PAR";
      break;
    case "MUELLE COSUGO":
      clave_muelle = "PAR";
      break;
    case "MUELLE PRIVADO CARLOS DAVID":
      clave_muelle = "PAR";
      break;
  }
  //85
  if (folio <= 85) {
    return folio_number;
  } else {
    let otro_folio = folio_number - 85;
    const folio_number_2 = otro_folio.toString().padStart(4, "0");
    return `${folio_number_2}/${muelle_folio}/${clave_muelle}/${day}${month}${year}`;
  }
};
